import { EntityTable } from "packable-components";
import { logDebug } from "packable-components";

import {
  IOrderSummary,
  IOrderTableProps,
  IOrderTableState,
} from "./Order.types";

import "./Order.css";

export class OrderTable extends EntityTable {
  state: IOrderTableState;
  constructor(props: IOrderTableProps) {
    logDebug("OrderTable PROPS");
    logDebug(props);
    super(props);
    this.state = this.populateState(props);
  }

  populateState(props: any) {
    let superState = super.populateState(props);
    let state: IOrderTableState = {
      ...superState,
    };
    return state;
  }

  ///////////////////////
  //// API callbacks ////
  ///////////////////////
  ///////////////////////////
  //// END API callbacks ////
  ///////////////////////////
  // OVERRIDE
  onEntitiesGetSuccess(data: any): void {
    let itemRows = data.data;
    if (data.data !== undefined && data.data !== null) {
      itemRows = data.data.map((row: IOrderSummary) => {
        const userName = row.userFirstName + " " + row.userLastName;
        return {
          ...row,
          userName: userName,
        };
      });
    }
    data.data = itemRows;
    super.onEntitiesGetSuccess(data);
  }
  // OVERRIDE
  onEntitiesSearchSuccess(data: any): void {
    let itemRows = data.data.map((row: IOrderSummary) => {
      const userName = row.userFirstName + " " + row.userLastName;

      return {
        ...row,
        userName: userName,
      };
    });
    data.data = itemRows;
    super.onEntitiesSearchSuccess(data);
  }
}

export default OrderTable;
